/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TicketTypeDto } from '../../models/ticket-type-dto';

export interface CenterTicketTypeControllerFindAllTypes$Params {
  centerId: string;
  query?: string;
}

export function centerTicketTypeControllerFindAllTypes(http: HttpClient, rootUrl: string, params: CenterTicketTypeControllerFindAllTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TicketTypeDto>>> {
  const rb = new RequestBuilder(rootUrl, centerTicketTypeControllerFindAllTypes.PATH, 'get');
  if (params) {
    rb.path('centerId', params.centerId, {});
    rb.query('query', params.query, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TicketTypeDto>>;
    })
  );
}

centerTicketTypeControllerFindAllTypes.PATH = '/api/ticket-type/center/{centerId}';
